import { Component, Input } from "@angular/core";
import Gender from "../../../models/gender";
import CredentialType from "../../../models/resource-management/credential-type.enum";
import CredentialedResource from "../../../models/resource-management/credentialed-resource";
import Volunteer from "../../../models/resource-management/volunteers/volunteer";
import VolunteerAvailabilityPreference from "../../../models/resource-management/volunteers/volunteer-availability-preference";
import VolunteerLocationPreference from "../../../models/resource-management/volunteers/volunteer-location-preference";
import { VolunteerType } from "../../../models/resource-management/volunteers/volunteer-type";

interface LocationWithRadius {
  zipCode: string;
  radius: number;
  radiusMeasurement: string;
}

interface SchedulePreferences {
  day: string;
  availabilities: string;
}

@Component({
  selector: "volunteer-details",
  templateUrl: "volunteer-details.html",
})
export class VolunteerDetailsComponent {
  private _resource: CredentialedResource;
  private _volunteer: Volunteer;

  availabilities: SchedulePreferences[] = [];
  locationPreferences: LocationWithRadius[] = [];
  volunteerTypes: string[] = [];

  Gender = Gender;
  CredentialType = CredentialType;

  constructor() {
    console.log("Hello VolunteerDetailsComponent Component");
  }

  get volunteer(): Volunteer {
    return this._volunteer;
  }

  @Input()
  set resource(value: CredentialedResource) {
    this._resource = value;
    this._volunteer = value as Volunteer;

    this.populateLocationPreferences();
    this.populateVolunteerTypes();
    this.populateAvailabilities();
  }

  private populateAvailabilities(): void {
    if (!this.volunteer.preferences) return;
    if (!this.volunteer.preferences.schedule) return;
    if (!this.volunteer.preferences.schedule.availabilities) return;

    this.availabilities =
      this.volunteer.preferences.schedule.availabilities.map(
        (x: VolunteerAvailabilityPreference) => {
          const day = x.day.substring(0, 1);
          let a: string[] = [];

          if (x.morning === true) {
            a.push("Morning");
          }

          if (x.afternoon === true) {
            a.push("Afternoon");
          }

          if (x.evening === true) {
            a.push("Evening");
          }

          if (a.length === 0) {
            a.push("Unavailable");
          }

          return {
            day: day,
            availabilities: a.join(","),
          };
        }
      );
  }

  private populateLocationPreferences(): void {
    if (!this.volunteer.preferences) return;
    if (!this.volunteer.preferences.schedule) return;
    if (!this.volunteer.preferences.schedule.locationPreferences) return;

    this.locationPreferences =
      this.volunteer.preferences.schedule.locationPreferences.map(
        (x: VolunteerLocationPreference) => {
          return {
            zipCode: x.zipCode,
            radius: x.radius,
            radiusMeasurement: "mi",
          };
        }
      );
  }

  private populateVolunteerTypes(): void {
    if (!this.volunteer.volunteerType) return;
    let s: string[] = [];

    if (
      (this.volunteer.volunteerType & VolunteerType.OFFICE_ADMIN) ===
      VolunteerType.OFFICE_ADMIN
    ) {
      s.push("Office Admin");
    }
    if (
      (this.volunteer.volunteerType &
        VolunteerType.COMPANION_SUPPORT_TO_PATIENT_FAMILY) ===
      VolunteerType.COMPANION_SUPPORT_TO_PATIENT_FAMILY
    ) {
      s.push("Companion Support to Patient Family");
    }
    if (
      (this.volunteer.volunteerType &
        VolunteerType.PROFESSIONAL_SERVICE_TO_PATIENT_FAMILY) ===
      VolunteerType.PROFESSIONAL_SERVICE_TO_PATIENT_FAMILY
    ) {
      s.push("Professional Service to Patient Family");
    }
    if (
      (this.volunteer.volunteerType & VolunteerType.SPECIAL_PROJECTS) ===
      VolunteerType.SPECIAL_PROJECTS
    ) {
      s.push("Special Projects");
    }

    this.volunteerTypes = s;
  }
}



// WEBPACK FOOTER //
// ./src/components/company-resources-detail/volunteer-details/volunteer-details.ts